<template>
  <div id="wrapper">
    <TextHeader />
    <Loading v-if="!this.item" />
    <div id="content" class="w-container" v-if="this.item">
      <h2 class="title">{{ item.title }}</h2>
      <div class="date">{{ item.date }}</div>
      <div class="font-fira" v-html="item.text"></div>
    </div>
    <!--    <MoreNews class="w-container"/>-->
  </div>
</template>

<script>
import Loading from "../Loading";
import TextHeader from "../TextHeader";

export default {
  name: "NewsDetails",
  components: { TextHeader, Loading },
  data() {
    return {
      item: null
    };
  },
  mounted() {
    this.update();
  },
  watch: {
    $route() {
      this.update();
    }
  },
  methods: {
    update() {
      this.$http
        .get("news/" + this.$route.params.slug + "/")
        .then(this.handleResponse);
    },
    handleResponse(response) {
      this.item = response.data;
      document.title = this.item.title + " | Madrigal";
    }
  }
};
</script>

<style scoped>
.title {
  position: relative;
  z-index: 2;
  margin-top: 54px;
  margin-bottom: 20px;
  color: #000;
  line-height: 40px;
}

.date {
  margin-bottom: 65px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-top: 1px none #dbd2d2;
  border-bottom: 1px none #dbd2d2;
  color: #a3a3a3;
  font-size: 1em;
  line-height: 1.5em;
  font-weight: 400;
  letter-spacing: 0.02em;
}

#content {
  margin-bottom: 55px;
  padding-bottom: 55px;
  font-family: "Fira Sans", sans-serif;
  color: #000;
  font-size: 1.15em;
  line-height: 1.4em;
  font-weight: 300;
  text-align: left;
}

.w-container {
  max-width: 768px;
  padding: 0 15px;
}
</style>
